import { BasicClient } from '@/utils/httpClient'
export default class Employee {
  client
  constructor() {
    this.client = new BasicClient()
  }

  getAddressInfo(userId) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/address`, 'GET')
  }

  getIdentifyInfo(userId) {
    return this.client.exec(`/v2/selfservice-manager/${userId}/me`, 'GET')
  }

  getEmployeePersonalInfo(userId) {
      return this.client.exec(`/v2/admin-mod/users/${userId}`, 'GET')
  }

  getBankInfo (userId) {
      return this.client.exec(`/v2/selfservice-manager/${userId}/bank`, 'GET')
  }

  getContactInfo(userId) { 
    return this.client.exec(`/v2/selfservice/${userId}/contact`, 'GET')
  }

  getRequestHistory() {
    return this.client.exec('workflow/document-solicit', 'GET')
  }

  getDocumentPages(id, hash) {
    return this.client.exec(`/v2/uploaddocuments/pages/${id}/${hash}`, "GET")
  }
  getDocumentUploaded(id, hash, page) {
    return this.client.renderImage(`/v2/uploaddocuments/dowloadS3/${id}/${hash}/${page}`)
  }

  getDocumentPagesFS(id, docId){
    return this.client.exec(`/documents/pages/${id}/${docId}`, "GET")
  }

  getDocumentUploadedFS(appId, docId, page) {
    return this.client.renderImage(`/documents/view/${appId}/${docId}/png/${page}`)
  }
}